module.exports = require("./bo-IN.d.ts");